import gql from 'graphql-tag'

export const setAutopayPayment = gql(
`mutation setPaymentMethodOnCart($cartId: String!, $backUrl: String!, $agreementsIds: String, $code: String!) {
  setPaymentMethodOnCart(
    input: {
      cart_id: $cartId
      payment_method: {
          code: $code
          bluepayment: {
              create_payment: true
              back_url: $backUrl,
              agreements_ids: $agreementsIds
            }
      }
  }) {
    cart {
      selected_payment_method {
        code
        title
      }
    }
  }
} 
`)
